import { cn } from "@/utils";
import { canvasToolbarIconClassName } from "../../components/toolbar/canvasToolbarIcon";

/** Three stacked lines (solid, dashed, dotted) — outline / stroke trigger. */
export function BorderStyleMenuIcon({ className }: { className?: string }) {
  return (
    <svg
      className={cn(canvasToolbarIconClassName, className)}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <line
        x1="2"
        y1="3.5"
        x2="14"
        y2="3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="2"
        y1="8"
        x2="14"
        y2="8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="3.5 2.5"
      />
      <line
        x1="2"
        y1="12.5"
        x2="14"
        y2="12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="1 2.5"
      />
    </svg>
  );
}
